import { useBeforeUnload } from 'hooks/utilHooks';
import { useEffect } from 'react';
import history from 'util/history';

type Props = {
  block: boolean;
  children?: any;
  message?: string;
};

/* https://stackoverflow.com/questions/67812387/prevent-going-back-conditionally-with-react-router-dom-5 */

/**
 * Custom form with block state
 * if state is block, the user will be prompted for save or discard changes
 *
 * @param {Props} { block, children }
 * @return {*}
 */
const NavigationPrompt = ({
  block,
  children,
  message = 'Existem alterações não salvas. Deseja realmente voltar?',
}: Props) => {
  useEffect(() => {
    // @ts-ignore
    const unblock = history.block((location, action) => {
      if (block) {
        return window.confirm(message);
      }
      return true;
    });

    return () => {
      unblock();
    };
  }, [block, message]);

  useBeforeUnload({
    when: block,
    message,
  });

  return <>{children}</>;
};

export default NavigationPrompt;

